/**
 * User-facing translation for cloud-runtime connect errors.
 *
 * The connect retry loop tears down + re-establishes the WS scope on each
 * attempt; an in-flight bootstrap fiber gets interrupted, and Effect squashes
 * that interrupt-only cause into the generic, unhelpful string
 * "All fibers interrupted without error". When that string is the terminal
 * error a user actually sees (the VM was still booting through every retry),
 * translate it into something actionable instead of leaking the Effect
 * internals. Mirrors formatCodexAuthStartError in SettingsPanels.tsx.
 */
export function formatCloudConnectStartError(error: unknown): string {
  const message =
    error instanceof Error ? error.message : typeof error === "string" ? error : String(error);
  if (/All fibers interrupted without error/i.test(message)) {
    return "Forge is still starting your cloud project. Wait a moment, then try again.";
  }
  return message || "Could not connect to your cloud project. Please try again.";
}
